export default {
    title: "訂單詳情",
    product_name: "品項",
    custom_content: "獎勵內容",
    game_name: "遊戲",
    server_name: "伺服器",
    roleid: "角色ID",
    pay_title: "儲值方式",
    money: "儲值金額",
    order_id: "訂單號",
    pay_time: "時間",
    coupon_code: "優惠碼",
    all_ratio: "贈送比例",
    button: {
        back: "返回儲值頁",
        againRecahrge: "再儲一筆"
    }
}